import React from 'react';
import { useDynamicParameters } from 'context/DynamicParameters/DynamicParametersContext';
import classNames from 'classnames';
import { IContentImageUpload } from '../types';

interface IContentImageProps {
  upload: IContentImageUpload;
  index: number;
  className?: string;
  imgClassName?: string;
  onClick?: (uploadIndex: number) => void;
  overlayText?: string;
}

export const ContentImage = (props: IContentImageProps) => {
  const params = useDynamicParameters();
  const { MARKETING_MANAGER_BASE_URL } = params.dynamicParameters;

  // Create srcset string for responsive images
  const srcset = Object.entries(props.upload.sizes)
    .map(([size, details]) => `${MARKETING_MANAGER_BASE_URL}/opportunity/v1/media/${details.path} ${details.width}w`)
    .join(', ');

  // Use the small size as the default src
  const defaultSrc = `${MARKETING_MANAGER_BASE_URL}/opportunity/v1/media/${props.upload.sizes.s.path}`;

  const sizes = [
    `(max-width: 640px) ${props.upload.sizes.s.width}px`,
    `(max-width: 768px) ${props.upload.sizes.m.width}px`,
    `(max-width: 1024px) ${props.upload.sizes.l.width}px`,
    `(max-width: 1279px) ${props.upload.sizes.xl.width}px`,
  ].join(', ');

  return (
    <div
      onClick={() => {
        props.onClick && props.onClick(props.index);
      }}
      className={classNames(
        'relative bg-cover bg-center',
        {
          'cursor-pointer': props.onClick,
        },
        props.className
      )}
    >
      <img
        style={{
          backgroundImage: `url('${defaultSrc}')`,
        }}
        src={defaultSrc}
        srcSet={srcset}
        sizes={sizes}
        alt={props.upload.displayName}
        className={classNames('object-cover w-full h-full bg-cover bg-center', props.imgClassName)}
        loading="lazy"
      />

      {props.overlayText && (
        <span className="bg-black/50 w-full h-full absolute top-0 left-0 right-0 bottom-0">
          <span className="text-white font-pt-sans text-14px underline absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]">
            {props.overlayText}
          </span>
        </span>
      )}
    </div>
  );
};